import { applicationApi } from '../../common/api';
import { QuizQuestion, QuizRecord } from './types';

// Define a service using a base URL and expected endpoints
export const quizApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuizQuestion: builder.query<QuizQuestion[], void>({
      query: () => `quiz/question`,
      providesTags: [{ type: 'QuizQuestions', id: 'LIST' }],
    }),
    getAllQuizRecord: builder.query<QuizRecord[], void>({
      query: () => `quiz/record`,
      providesTags: [{ type: 'QuizRecords', id: 'LIST' }],
    }),
    getQuizMonthlyReport: builder.query<any[], void>({
      query: () => `quiz/record/monthly-report`,
      providesTags: [{ type: 'QuizMontlyReport', id: 'LIST' }],
    }),
    getQuizQuestion: builder.query<QuizQuestion, string>({
      query: (query) => `quiz/question/${query}`,
    }),
    createQuizQuestion: builder.mutation<QuizQuestion, any>({
      query: (body) => ({
        url: '/quiz/question',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'QuizQuestions', id: 'LIST' }],
    }),
    deleteQuizQuestion: builder.mutation<any, number>({
      query: (id) => ({
        url: `quiz/question/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'QuizQuestions', id: 'LIST' }],
    }),
    deleteQuizRecord: builder.mutation<any, number>({
      query: (id) => ({
        url: `quiz/record/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'QuizQuestions', id: 'LIST' }],
    }),
    updateQuizQuestion: builder.mutation<QuizQuestion, any>({
      query: (body) => ({
        url: `/quiz/question/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'QuizQuestions', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllQuizQuestionQuery,
  useGetQuizQuestionQuery,
  useCreateQuizQuestionMutation,
  useDeleteQuizQuestionMutation,
  useUpdateQuizQuestionMutation,
  useGetAllQuizRecordQuery,
  useDeleteQuizRecordMutation,
  useGetQuizMonthlyReportQuery,
} = quizApi;
